import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=6b7f6c52&"
import script from "./ModalFooter.vue?vue&type=script&lang=js&"
export * from "./ModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports